import api from '../utils/api';

const SEND_OTP_TIMEOUT_MS = 8000;
const RATE_LIMIT_KEY = 'sparepe_otp_rate_limit_until';

/** B-01A send-otp; falls back to legacy /auth/otp/send if needed. */
export async function sendLoginOtp(phone) {
  const portal = localStorage.getItem('authPortal') || 'new';

  try {
    const response = await api.post(
      '/auth/send-otp',
      { phone, portal },
      { timeout: SEND_OTP_TIMEOUT_MS, withCredentials: true }
    );
    const body = response.data || {};
    return {
      success: body.success !== false,
      message: body.message || 'OTP sent',
      otpId: body.otpId,
      devOtp: body.devOtp,
    };
  } catch (specErr) {
    if (specErr.response?.status && specErr.response.status !== 404) {
      throw specErr;
    }
    const response = await api.post(
      '/auth/otp/send',
      { mobileNumber: phone, portal },
      { timeout: SEND_OTP_TIMEOUT_MS, withCredentials: true }
    );
    const body = response.data || {};
    const otpId =
      body.otpId ||
      body.data?.otpId ||
      (typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `otp-${Date.now()}-${phone}`);

    return {
      success: body.success !== false,
      message: body.message || 'OTP sent',
      otpId,
      devOtp: body.data?.devOtp || body.devOtp,
    };
  }
}

export function mapSendOtpError(error) {
  const status = error.response?.status;
  const serverMsg = error.response?.data?.message;

  if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
    return { type: 'timeout', message: 'Request timed out. Please try again.' };
  }

  if (!error.response && (error.message === 'Network Error' || !navigator.onLine)) {
    return { type: 'offline', message: 'No internet connection. Check your network.', toast: true };
  }

  if (status === 429) {
    const until = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem(RATE_LIMIT_KEY, String(until));
    return {
      type: 'rate_limit',
      message: 'Too many attempts. Try again in 24 hours.',
      rateLimitUntil: until,
    };
  }

  if (status === 503) {
    return { type: 'service', message: 'Could not send OTP. Try again in a moment.' };
  }

  if (status === 400) {
    return {
      type: 'validation',
      message: serverMsg || 'Enter a valid 10-digit mobile number.',
    };
  }

  return {
    type: 'unknown',
    message: serverMsg || error.message || 'Could not send OTP. Try again in a moment.',
  };
}

export function getStoredRateLimitUntil() {
  const raw = localStorage.getItem(RATE_LIMIT_KEY);
  if (!raw) return null;
  const until = Number(raw);
  if (!until || until <= Date.now()) {
    localStorage.removeItem(RATE_LIMIT_KEY);
    return null;
  }
  return until;
}

export function formatRateLimitCountdown(untilMs) {
  const remaining = Math.max(0, untilMs - Date.now());
  const hours = Math.floor(remaining / (60 * 60 * 1000));
  const minutes = Math.floor((remaining % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((remaining % (60 * 1000)) / 1000);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
